import React from 'react';
import { Box, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface AccountNavButtonsProps {
  canBack?: boolean;
  canForward?: boolean;
  onBack?: () => void;
  onForward?: () => void;
  size?: number;
}

const buttonSx = (size: number) => ({
  color: '#E7E9EA',
  backgroundColor: 'rgba(47, 51, 54, 0.8)',
  borderRadius: 1,
  width: size,
  height: size,
  '&:hover': { backgroundColor: 'rgba(47, 51, 54, 1)' },
  '&.Mui-disabled': {
    color: '#71767B',
    backgroundColor: 'rgba(47, 51, 54, 0.4)',
  },
});

const AccountNavButtons: React.FC<AccountNavButtonsProps> = ({
  canBack = false,
  canForward = false,
  onBack,
  onForward,
  size = 36,
}) => {
  if (!onBack && !onForward) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        flexShrink: 0,
      }}
    >
      <IconButton
        onClick={onBack}
        disabled={!canBack}
        aria-label="Previous account"
        size="small"
        sx={buttonSx(size)}
      >
        <ChevronLeftIcon sx={{ fontSize: size * 0.61 }} />
      </IconButton>
      <IconButton
        onClick={onForward}
        disabled={!canForward}
        aria-label="Next account"
        size="small"
        sx={buttonSx(size)}
      >
        <ChevronRightIcon sx={{ fontSize: size * 0.61 }} />
      </IconButton>
    </Box>
  );
};

export default AccountNavButtons;
